import { axiosFactory } from '../../../../client';
import * as ROUTES from './routes';

const reportingBaseURL = `${import.meta.env.VITE_APP_API_DOMAIN}/reporting/api`;
const timeout = 30000;

export const opsAdminReportingClient = axiosFactory(reportingBaseURL, timeout);

export const getCheckEligibility = () =>
  opsAdminReportingClient.get<void>(ROUTES.GET_CHECK_ELIGIBILITY);
